import React from 'react'

const About = () => {
  return (
    <div name="about" className='w-full h-screen bg-gradient-to-b from-gray-600 to-black text-white'>
        <div className='max-w-screen-lg p-4 mx-auto flex flex-col w-full h-full'>
            <div className='pb-8 pt-8'>
                <p className='text-4xl font-bold inline border-b-4 border-gray-500'>About Me</p>
            </div>

            <p className='text-xl mt-10'>I am a web developer and very keen on learning new technologies and building responsive web apps. Currently I am
                working as a backend developer specialised in Typescript and Nodejs Applications. I have completed my graduation
                in Computer Science and Engineering.
            </p>

            <br />

            <div>
                <p className='text-3xl font-bold inline border-b-4 border-gray-500'>Education</p>
            </div>

            <p className='text-xl text-white mt-5 pb-4'>Silicon Institute Of Technology, Bhubaneshwar</p>
            <p className='text-gray-400'>Computer Science & Engineering, 2018-2022</p> 
            <p className='text-gray-400 mt-2'>CGPA - 8.64 </p>
            <br />
            <p className='text-xl text-white mt-5 pb-4'>De Nobili School, FRI</p>
            <p className='text-gray-400'>Higher Secondary (ISC), 2015-2017</p>
            <p className='text-gray-400 mt-2'>Percentage - 85% </p>
            <br />
            <p className='text-xl text-white mt-5 pb-4'>Carmel School, Digwadih</p>
            <p className='text-gray-400'>Secondary (ICSE), 2015</p>
            <p className='text-gray-400 mt-2'>Percentage - 95.8% </p>
        </div>
    </div>
  )
}

export default About